import type { IconData } from '@stacksjs/iconify-core'

export const internetNetworkComputerUpload: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.955 22.85h-25.9V7.62h-1.53V25.9h1.53v1.53h9.14v1.52h1.52v-1.52h4.57v1.52h1.53v-1.52h9.14V25.9h1.52V7.62h-1.52zm-6.09-16.76h6.09v1.53h-6.09Zm-10.67 24.38v-1.52h-1.52V32h10.66v-3.05h-1.52v1.52z\"/><path fill=\"currentColor\" d=\"M13.715 15.24h4.57v1.52h-4.57Zm0 3.04h4.57v1.53h-4.57ZM15.245 0v1.52h-1.53v1.53h-1.52v1.52h-1.52v1.52h3.04v7.62h4.57V6.09h3.05V4.57h-1.52V3.05h-1.53V1.52h-1.52V0zM3.055 6.09h6.09v1.53h-6.09Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default internetNetworkComputerUpload
